<template>
    <span class="field password-field">
        <input type="password" v-model="innerValue" @blur="handleBlur"/>
    </span>
</template>

<script>
    //import Component from 'path/to/component'
    import FormElementMixin from '@/mixins/formElement.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleBlur(){
                this.$emit('validate')
            }
        },
        mixins:[
            FormElementMixin
        ],
        mounted: function () {

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/Password.vue